import { useMemo, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";

const COLORS = ["#f43f5e", "#6366f1", "#f59e0b", "#10b981", "#0ea5e9", "#d946ef", "#64748b", "#84cc16", "#f97316", "#14b8a6"];
const fmt = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

const last12 = () => {
  const out = []; const d = new Date(); d.setDate(1);
  for (let i = 11; i >= 0; i--) { const x = new Date(d.getFullYear(), d.getMonth() - i, 1); out.push(`${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}`); }
  return out;
};

export const CategoryCostChart = ({ records = [] }) => {
  const [tab, setTab] = useState("paid");
  const { cats, paid, equiv } = useMemo(() => {
    const paidRecs = records.filter((r) => Number(r.last_payment_amount) > 0);
    const cats = [...new Set(paidRecs.map((r) => r.category || "أخرى"))];
    const months = last12();
    const paid = months.map((m) => {
      const row = { month: m };
      paidRecs.filter((r) => (r.last_payment_date || "").startsWith(m)).forEach((r) => { const c = r.category || "أخرى"; row[c] = (row[c] || 0) + Number(r.last_payment_amount); });
      return row;
    });
    const equiv = cats.map((c) => ({ category: c, monthly: Math.round(paidRecs.filter((r) => (r.category || "أخرى") === c).reduce((a, r) => a + Number(r.last_payment_amount), 0) / 12) }))
      .sort((a, b) => b.monthly - a.monthly);
    return { cats, paid, equiv };
  }, [records]);
  if (!cats.length) return null;
  const btn = (k, l) => (
    <button onClick={() => setTab(k)} className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${tab === k ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`} data-testid={`cat-chart-tab-${k}`}>{l}</button>
  );
  return (
    <div className="space-y-3 rounded-2xl border border-slate-200 bg-white p-4" data-testid="category-cost-chart">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold text-slate-700">مقارنة المصروفات حسب التصنيف</p>
        <div className="flex gap-1.5">{btn("paid", "حسب شهر السداد")}{btn("equiv", "التكلفة الشهرية المكافئة")}</div>
      </div>
      <div className="h-72 w-full" dir="ltr">
        <ResponsiveContainer>
          {tab === "paid" ? (
            <BarChart data={paid} margin={{ top: 5, right: 5, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="month" tick={{ fontSize: 10 }} tickFormatter={(m) => m.slice(2).replace("-", "/")} />
              <YAxis tick={{ fontSize: 10 }} tickFormatter={fmt} width={55} />
              <Tooltip formatter={(v) => `${fmt(v)} ر.س`} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              {cats.map((c, i) => <Bar key={c} dataKey={c} stackId="a" fill={COLORS[i % COLORS.length]} />)}
            </BarChart>
          ) : (
            <BarChart data={equiv} layout="vertical" margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis type="number" tick={{ fontSize: 10 }} tickFormatter={fmt} />
              <YAxis type="category" dataKey="category" tick={{ fontSize: 11 }} width={120} />
              <Tooltip formatter={(v) => `${fmt(v)} ر.س / شهر`} />
              <Bar dataKey="monthly" fill="#6366f1" radius={[0, 6, 6, 0]} />
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
      <p className="text-[11px] text-slate-500">{tab === "paid" ? "مبلغ آخر سداد موزّع على شهر تاريخ السداد خلال آخر 12 شهراً." : "مبلغ آخر سداد (سنوي) ÷ 12 لكل تصنيف."}</p>
    </div>
  );
};
